import { ElementRef, Input, SimpleChanges } from '@angular/core';
import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { Movies, MovieService } from 'src/app/Core/services/movie.service';
import { UtilService } from 'src/app/Core/services/util.service';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Core/services/data';
import { MessageService } from 'src/app/Core/services/message.service';
import videojs from 'video.js';
import { TranslateService } from '@ngx-translate/core';
import { ImageProxyService } from 'src/app/Core/services/image-proxy-service';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
declare var Hls;
@Component({
  selector: 'app-movie-container',
  templateUrl: './movie-container.component.html',
  styleUrls: ['./movie-container.component.css']
})
export class MovieContainerComponent implements OnInit {
  @ViewChild('scrollBox', { static: false }) scrollBox: ElementRef;

  @Input() selectedcategory: any;
  @Input() isLoading: any;

  movieList: any;
  defaultList: any;
  sortType: any;
  subscription: Subscription;
  isSort: boolean = true;
  profile_id:any;
  filterTerm: string;
  JSONDatas = [];
  categoryId: any;
  stream_Url: any;
  filteredMovie:any =[];
  isLocal:boolean= true;
  @ViewChild('popover') popover: any;
  sortButton: any = [{ label: 'Default', val: 'default', selected: true },
  { label: 'A - Z', val: 'atoz', selected: false },
  { label: 'Z - A', val: 'ztoa', selected: false },
  ];
  translation=['COMMON.DEFAULT','COMMON.A-Z','COMMON.Z-A']
  page = 1;
  limit = 50;
  movie:any;
  isLoadingMore = false;

  constructor(private router: Router,private playlistService:PlaylistService,private imageProxyService: ImageProxyService, private movieService: MovieService, private utilService: UtilService, private messageService: MessageService,private translate:TranslateService) {
    this.subscription = this.utilService.sortingType.subscribe((res: any) => {
      this.sortType = res;
      if (this.sortType.type == 'Movies') {
        this.sortMovie('name', this.sortType.sub_category);
      }
    });
    
  }


  async ngOnInit(){
    const profileData = JSON.parse(localStorage.getItem('Profile'));
    const mtoken = localStorage.getItem('mtoken')
    this.profile_id = profileData.profile_id;
    if(mtoken){
      this.isLocal = false;
      this.checkFav(this.profile_id)
    }else{
      this.isLocal = true;
    }
    // const total = await this.movieService.loadMovies();
    // console.log(total);
    // if(total){
    //   this.onCategorySelect('all')
    // }

  }

  checkFav(id:any){
    this.playlistService.getAllFavData(id).subscribe((res:any)=>{
      // console.log(res);
      const fabData = res;
      // const favMovieData = fabData.filter(item => item.content_id == '' );
      // console.log(favMovieData,'fav movies data');
      let index;
      fabData.map((ele: any) => {
        // console.log(ele,'elements ==>',this.movieList);
        
        index = _.findIndex(this.movieList, { stream_id : ele.content_id});
        // console.log(index,'index.',ele.content_id);
        
        if (index >= 0) {
          this.movieList[index].isFavourit = true;
        }
      });
     
    })
  }

  async ngOnChanges(changes: SimpleChanges){
    //  this.movie = await this.movieService.getMoviesByCategory(this.selectedcategory,this.page,this.limit);
    //   console.log(this.movie);
    //  this.movieList = this.movie;
    //  this.defaultList = this.movie;
    //   this.filteredMovie = this.movieList;
     if (changes['selectedcategory']) {
    this.page = 1;

    if (this.selectedcategory === 'all') {
      this.movieList = await this.movieService.getAllMovies(this.page, this.limit);
    } else {
      this.movieList = await this.movieService.getMoviesByCategory(this.selectedcategory, this.page, this.limit);
    }

    this.filteredMovie = this.movieList;
  }
  }

  async onCategorySelect(categoryId:string){
    this.selectedcategory = categoryId;
    this.page = 1;
    if(categoryId == 'all'){

      this.movie = await this.movieService.getAllMovies(this.page,this.limit);
      this.movieList = this.movie;
      // this.defaultList = this.movieList;
      this.filteredMovie= this.movieList
    }
    else{
     
    }
  }

  onScroll(event: any): void {
  const native = event.target;
  const atBottom = native.scrollTop + native.clientHeight >= native.scrollHeight - 100;

  if (atBottom && !this.isLoadingMore) {
    this.loadMoreMovies();
  }
}
// onScrollChange(index: number): void {
//   if (index + 20 >= this.filteredMovie.length && !this.isLoadingMore) {
//     this.loadMoreMovies(); 
//   }
// }


async loadMoreMovies() {
  this.isLoadingMore = true;
  this.page++;

  let more: Movies[];

  if (this.selectedcategory === 'all') {
    more = await this.movieService.getAllMovies(this.page, this.limit);
  } else {
    more = await this.movieService.getMoviesByCategory(this.selectedcategory, this.page, this.limit);
  }

  if (more && more.length > 0) {
    this.movieList = this.movieList.concat(more);
    this.filteredMovie = this.movieList;
  }

  this.isLoadingMore = false;
}

  // ngOnChanges(changes: SimpleChanges): void {
   
  //   if (this.selectedcategory) {
  //     this.movieList = this.selectedcategory;
  //     this.filteredMovie=this.movieList
  //     this.defaultList = this.selectedcategory;
  //     if(this.isLocal == false){
  //       this.checkFav(this.profile_id)
  //     }else{

  //       this.categoryId = this.selectedcategory[0]?.category_id;
  //       let index, savedArray;
  //       savedArray = JSON.parse(localStorage.getItem(Constant.MOVIES_FAV)) || [];
  //       savedArray.map((ele: any) => {
  //         index = _.findIndex(this.movieList, { stream_id: ele.id });
  //         if (index >= 0) {
  //           this.movieList[index].isFavourit = true;
  //         }
  //       });
  //     }

  //   if (this.filterTerm && this.filterTerm.trim()) {
  //     this.searchMovies();
  //   } else {
  //     this.filteredMovie = this.movieList;
  //   }
  //   }
  // }
  getProxiedImageUrl(url: string): string {
    return this.imageProxyService.getProxiedImageUrl(url);
  }
 preventSpace(event){
  this.utilService.preventSpace(event)
 }

  playMovie(movieId) {
    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/movies/watch/' + movieId])
    // );
    // window.open(url, '_blank');
  }

  

  onSaves(item){
    const extension = item.container_extension;
    this.stream_Url = this.movieService.getStremMovieUrl(item.stream_id, extension);
    const body = {
      profile_id:this.profile_id,
      content_type: item.stream_type,
      content_id: item.stream_id,
      content_url: this.stream_Url
    }
    console.log(item,body);
    
    this.playlistService.addFavorites(body).subscribe((res:any) =>{
      console.log(res);
    })
  }

  onSave(item: any) {
    
    if(this.isLocal == true){
    let savedArray = [];
    let isExist: any;
    let index;
    const msg =this.translate.instant('COMMON.ADDED_SUCCESS_MSG')
    savedArray = JSON.parse(localStorage.getItem(Constant.MOVIES_FAV)) || [];
    if (savedArray.length > 0) {
      isExist = _.findIndex(savedArray, { id: item.stream_id });
      if (isExist == -1) {
        item.isList = true;
        item.id = item.stream_id;
        item.fullUrl = localStorage.getItem(Constant.FULLURL_KEY)
        savedArray.push(item);
        localStorage.setItem(Constant.MOVIES_FAV, JSON.stringify(savedArray));
        index = _.findIndex(this.movieList, { stream_id: item.stream_id });
        if (index >= 0) {
          this.movieList[index].isFavourit = true;
        }
        this.utilService.showErrorSuccess(`${msg}`);
      }
      if (isExist >= 0) {
        this.utilService.showErrorInfo('Item alreadey added to favourite')
      }

    }
    else { //first
      item.isList = true;
      item.id = item.stream_id;
      item.fullUrl = localStorage.getItem(Constant.FULLURL_KEY)
      savedArray.push(item);
      localStorage.setItem(Constant.MOVIES_FAV, JSON.stringify(savedArray));
      index = _.findIndex(this.movieList, { stream_id: item.stream_id });
      if (index >= 0) {
        this.movieList[index].isFavourit = true;
      }
      this.utilService.showErrorSuccess(`${msg}`);


    }
  }else{
    const extension = item.container_extension;
    this.stream_Url = this.movieService.getStremMovieUrl(item.stream_id, extension);
    const urls = [this.stream_Url ,item.stream_icon]
    const body = {
      profile_id:this.profile_id,
      content_type: item.stream_type,
      content_id: item.stream_id,
      content_url: urls
    }
    console.log(item,body);
    
    this.playlistService.addFavorites(body).subscribe((res:any) =>{
      console.log(res);
    })
  }
  }

  deleteFavourite(item: any) {
    item.id = item.stream_id;
    const msg = this.translate.instant('COMMON.REMOVE_SUCCESS_MSG')
    this.utilService.deleteFavourit(Constant.MOVIES_FAV, item, (result: any) => {
      if (result) {
        this.utilService.showErrorSuccess(`${msg}`);
        let index = _.findIndex(this.movieList, { stream_id: item.id });
        if (index >= 0) {
          this.movieList[index].isFavourit = false;
        }
      }
    });
  }

  sortMovie(property, subtype: any) {
    // this.isSort = !this.isSort;
    // this.utilService.commonSort(this.isSort, 'name', this.movieList);
    let ascDesc;
    if (subtype == 'default') {
      this.movieList = this.defaultList;
      this.filteredMovie=this.movieList

    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });
    if (ascDesc) {
      this.utilService.sortCommonCategorywise(property, ascDesc, this.movieList, (callback) => {
        this.movieList = callback;
        this.filteredMovie=this.movieList
      });
    }

  }
  sort(type: any, subCategory: any) {
    let passModal: any = {
      type: type,
      sub_category: subCategory
    };
    this.sortButton.map((ele: any) => {
      (subCategory == ele.val) ? ele.selected = true : ele.selected = false;
    });
    this.utilService.addSorting(passModal);
  }

  resetSort() {
    this.sortButton.map((ele: any) => {
      ele.selected = false;
      return ele;
    });
    this.sortButton[0].selected = true;
  }
  
  translateFilter(index:any):string{
    return this.translation[index]
  }

  gotoDetail(id) {

    let passModal: any = {
      type: 'Movies',
      sub_category: 'default'
    };
    this.utilService.addSorting(passModal);
    // [routerLink]="['/movies/info/'+select.stream_id]" [queryParams]="{movieBy: 'movies',categoryId:categoryId}"
    this.router.navigate(['/movies/info/' + id], { queryParams: { movieBy: 'movies', categoryId: this.categoryId } });
  }

  searchMovies(){
    this.filteredMovie = this.movieList.filter((item:any)=>item.name.toLowerCase().includes(this.filterTerm.toLowerCase()));
    console.log(this.filteredMovie);
  }
  clearSearch(){
    this.filterTerm =''
    this.filteredMovie = this.movieList

  }

  ngOnDestroy() {
    if (this.sortType) {
      this.subscription.unsubscribe();
    }
  }

}
